import { render, staticRenderFns } from "./WeChat.vue?vue&type=template&id=6722cc12&scoped=true&"
import script from "./WeChat.vue?vue&type=script&lang=js&"
export * from "./WeChat.vue?vue&type=script&lang=js&"
import style0 from "./WeChat.vue?vue&type=style&index=0&id=6722cc12&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6722cc12",
  null
  
)

export default component.exports